import './styles/Text.css';

export default function Text({ children, className, style, title=null, extraSmallPlus=false, extraSmall=false, small=false, medium=false, large=false, justify=false, paragraph=false, onClick=null }) {
  const parsed = children && ['"', '“'].indexOf(children[0]) !== -1 ? children.substring(1, children.length - 2) : children;

  const classes = ['text-custom__component'];

  if(className) {
    classes.push(...className.split(' ').filter(Boolean));
  }

  if(extraSmallPlus) classes.push('extra-small-plus');
  if(extraSmall) classes.push('extra-small');
  if(small) classes.push('small');
  if(medium) classes.push('medium');
  if(large) classes.push('large');
  if(justify) classes.push('justify');
  if(paragraph) classes.push('paragraph');

  const mergedClassName = classes.join(' ');

  if(paragraph) {
    return (
      <p style={style} className={mergedClassName} onClick={onClick} title={title ?? undefined}>
        {parsed}
      </p>
    ); 
  }

  return (
    <>
      <span style={style} className={mergedClassName} onClick={onClick} title={title ?? undefined}>
        {parsed}
      </span>
    </>
  );
}
